import { Pipe, PipeTransform } from '@angular/core';
/*
 * Filter the array of object by field name
 * Usage:
 *   items | array-filter:fieldName:fieldValue
 * Example:
 *   {{ [{name:'Mario', active: true}, {name:'Rossi', active: false}] |  array-filter:'active':true }}
 *   return: [{name:'Mario', active: true}]
*/
@Pipe({ name: 'arrayFilter', pure: false })
export class ArrayFilterPipe implements PipeTransform {
    transform(items: any[], fieldName: string, fieldValue: any): any[] {
        if (!items) {
            return [];
        }

        return items.filter(item => item[fieldName] === fieldValue);
    }
}
